import { withSvgIcon } from './withSvgIcon';

export const Cart = withSvgIcon(
  <>
    <path
      d="M4 4L5.99998 4L6.49998 6M8 12H18L20 6H6.49998M8 12L7.99998 16H16M8 12L6.49998 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <circle cx="7.5" cy="19.5" r="1.5" fill="currentColor" />
    <circle cx="16.5" cy="19.5" r="1.5" fill="currentColor" />
  </>,
  { viewBox: '0 0 24 24' },
);
